export default __webpack_public_path__ + "static/media/about-inside.85aac4cb.jpeg";